'use client';

import { loginUrl } from 'lowcode/utils/service/baseUrl';
import { fetchPost } from '../service/FetchClient';
import getDefaultHeader from '../service/getDefaultHeader';

export const calendarCreate = async (locale: string, data: any) => {
    const headers: any = getDefaultHeader(locale);

    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';

    const res = await fetch(`${loginUrl(locale)}/website/calendar/create`, {
        method: 'POST',
        headers: {
            ...headers,
        },
        body: JSON.stringify(data || {}),
        next: { revalidate: 0 },
    });

    const myBlob = await res.blob();
    const url = window.URL.createObjectURL(myBlob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = 'todo-1.ics';

    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    //window.open(url, '_blank');
};

export const calendarCreate2 = async (locale: string, data: any) => {
    console.log('111');
    const res = await fetchPost(`${loginUrl(locale)}/website/calendar/create`, locale, data);
};
